"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    LESSON: 'lesson',
    SESSION: 'session',
};
//# sourceMappingURL=event.js.map